exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slot-wrapper-design[data-v-6b6d51b0]{width:100%;min-height:26px;background:linear-gradient(45deg, #ccc 25%, #eee 0, #eee 50%, #ccc 0, #ccc 75%, #eee 0);background-size:20px 20px;text-align:center}.slot-wrapper-design .slot-title[data-v-6b6d51b0]{font-size:13px}\n", ""]);

// exports
